import { useMutation } from "react-query";
import api from "../../client";
import { UserChecklistTaskAddPayload } from "../../types/user-checklist";

const postData = async (payload: UserChecklistTaskAddPayload): Promise<{}> => {
  const { data } = await api.post<{}>(`/user/checklists/add-task`, payload);

  return data;
};

export const useUserChecklistTaskAdd = () => {
  return useMutation((payload: UserChecklistTaskAddPayload) => {
    return postData(payload);
  });
};
